import type { CreateUserTaskRequest } from "@/openapi/generated";

export type CreateUserTaskPayloadInput = {
  title: string;
  assigneeUserId: number;
  description?: string | null;
  dueAt?: string | null;
};

/** Maps UI input to the POST body shape the API expects (all fields explicit). */
export function buildCreateUserTaskApiRequest(
  input: CreateUserTaskPayloadInput,
): CreateUserTaskRequest {
  const title = input.title.trim();
  const description = input.description?.trim();
  const dueAtRaw = input.dueAt?.trim();

  if (!title) {
    throw new Error("Title is required");
  }
  if (!Number.isFinite(input.assigneeUserId) || input.assigneeUserId <= 0) {
    throw new Error("Assignee is required");
  }

  let dueAt: Date | null = null;
  if (dueAtRaw && dueAtRaw.length > 0) {
    const parsed = new Date(dueAtRaw);
    dueAt = Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return {
    title,
    assigneeUserId: input.assigneeUserId,
    description: description && description.length > 0 ? description : null,
    dueAt,
  };
}
